import useGetArray from './useGetArray';

export default useGetArray;
export * from './useGetArray';
